<!-- Hosts the API's Swagger UI inside the Diagnostics area with the signed in user's bearer token
applied automatically, so endpoints can be exercised from "Try it out" without pasting a token. -->

@if (availability === 'checking') {
    <div class="container">
        <ws-ace-loader [hideLabel]="false" label="Checking whether Swagger is available&hellip;"></ws-ace-loader>
    </div>
}

@if (availability === 'unavailable') {
    <div class="container">
        <h1>SWAGGER</h1>
        <p class="text-danger">
            Swagger is not available in this environment. It is intentionally disabled in production.
        </p>
    </div>
}

@if (availability === 'noToken') {
    <div class="container">
        <h1>SWAGGER</h1>
        <p class="text-danger">No access token is available. Try signing in again.</p>
        <button type="button" class="ace-btn btn-sm btn-secondary btn-action" (click)="load()">Retry</button>
    </div>
}

@if (availability === 'notProxied') {
    <div class="container text-danger">
        <h1>SWAGGER</h1>
        <p>
            <strong>Swagger is not reachable from the dev server.</strong>
            The request for <code>{{ swaggerDocsUrl }}</code> was answered by the Angular dev server
            instead of the API, so the explorer would just load this application again.
        </p>
        <p>Add a <code>/swagger</code> entry to <code>ui/proxy.conf.json</code> alongside the existing <code>/api</code> entry:</p>
<pre>"/swagger": &#123;
    "target": "http://localhost:54779/",
    "secure": false
&#125;</pre>
        <p>
            Then restart <code>ng serve</code> &mdash; the proxy configuration is only read at startup.
            (<code>proxy.conf.json</code> is git-ignored, so this is a one-time local setup step.)
        </p>
        <button type="button" class="ace-btn btn-sm btn-secondary btn-action" (click)="load()">Check Again</button>
    </div>
}

@if (availability === 'available') {
    <div class="swagger-page">
        <div class="swagger-toolbar">
            <span>Your access token is applied automatically. Tokens expire &mdash; reload this page to refresh it.</span>
            <button type="button" class="ace-btn btn-sm btn-secondary btn-action" (click)="openInNewTab()">
                Open in New Tab
            </button>
        </div>
        <div class="swagger-frame-wrapper">
            <iframe #swaggerFrame
                    class="swagger-frame"
                    [class.is-loading]="frameLoading"
                    [src]="swaggerFrameUrl"
                    title="Swagger UI"
                    (load)="onFrameLoaded(swaggerFrame)"></iframe>
            @if (frameLoading) {
                <ws-ace-loader class="swagger-loader"
                               [hasOverlay]="true"
                               [darkOverlay]="false"
                               [hideLabel]="false"
                               [label]="frameLoadingMessage"
                               size="3"></ws-ace-loader>
            }
        </div>
    </div>
}
